// extracted by mini-css-extract-plugin
module.exports = {"title":"Welcome_title__2kMUM","subtitle":"Welcome_subtitle__1OioM","link":"Welcome_link__3HSdO","button-container":"Welcome_button-container__5lMdO"};